// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lhPS9","delete":"styles_delete__2d8Zi","update":"styles_update__c_mZ6","add":"styles_add__2eh6W"};